import gql from "graphql-tag"

export const DELETE_WALLEY_CHECKOUT_CONFIG = gql`
  mutation deleteWalleyCheckoutConfig($id: ID!) {
    deleteWalleyCheckoutConfig(id: $id) {
      status
    }
  }
`
